export function getCardType(): "interview-days" {
  return "interview-days";
}
